import { useEffect, useState } from 'react';

interface PhoneLinks {
  href: string;
  display: string;
}

export const usePhoneLinks = (phoneNumber: string): PhoneLinks => {
  const [isInternational, setIsInternational] = useState(false);

  useEffect(() => {
    // Try to detect user's country using the timezone
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    setIsInternational(!timezone.includes('America/'));
  }, []);

  const formatPhoneNumber = (phone: string): string => {
    // Remove any non-numeric characters
    const cleaned = phone.replace(/\D/g, '');
    
    // Format with area code
    return `${cleaned.slice(0, 3)}.${cleaned.slice(3, 6)}.${cleaned.slice(6)}`;
  };

  const getPhoneLink = (phone: string): string => {
    const cleaned = phone.replace(/\D/g, '');
    
    // For international users, use WhatsApp
    if (isInternational) {
      return `https://wa.me/1${cleaned}`;
    }
    
    // For US users, use tel: protocol
    return `tel:+1${cleaned}`;
  };

  return {
    href: getPhoneLink(phoneNumber),
    display: formatPhoneNumber(phoneNumber)
  };
};